/**
 * Cookie-consent configuration — the house CMP on vanilla-cookieconsent v3
 * (js/vendor/cookieconsent-v3.min.js; PHP side: inc/setup/consent.php).
 *
 * The WiNGZZ five-category model with the Dutch house texts (the same copy the
 * classic and headless stacks show). Wires three things to the engine's
 * consent lifecycle:
 *  1. Google Consent Mode v2 updates (the gtag() seeded in <head>).
 *  2. The proof-of-consent log (admin-ajax ibizz_log_consent).
 *  3. The on-page Cookievoorkeuren form (template-parts/blocks/
 *     cookie-preferences), form#cookieconsentform.
 *
 * Server-provided config via wp_localize_script: window.ibizzConsent =
 * { ajaxUrl, nonce, policyUrl, revision }.
 */
(function () {
	var CC = window.CookieConsent;
	var cfg = window.ibizzConsent || {};
	if (!CC) return;

	// House mapping: category → Consent Mode v2 consent types.
	function gtagUpdate() {
		if (typeof window.gtag !== 'function') return;
		window.gtag('consent', 'update', {
			analytics_storage: CC.acceptedCategory('analytics') ? 'granted' : 'denied',
			ad_storage: CC.acceptedCategory('ads') ? 'granted' : 'denied',
			ad_user_data: CC.acceptedCategory('ads') ? 'granted' : 'denied',
			ad_personalization: CC.acceptedCategory('social') ? 'granted' : 'denied',
			personalization_storage: CC.acceptedCategory('interest') ? 'granted' : 'denied'
		});
	}

	// Proof-of-consent log (fire-and-forget). Logged on the first consent and
	// on every change — NOT on every page load (onConsent), that would flood.
	function logConsent(cookie) {
		if (!cfg.ajaxUrl || !cookie) return;
		var body = new URLSearchParams();
		body.append('action', 'ibizz_log_consent');
		body.append('_ajax_nonce', cfg.nonce || '');
		body.append('consent_id', cookie.consentId || '');
		body.append('revision', String(cookie.revision || 0));
		(cookie.categories || []).forEach(function (c) { body.append('categories[]', c); });
		fetch(cfg.ajaxUrl, { method: 'POST', body: body, keepalive: true }).catch(function () {});
	}

	// The on-page preferences form (the Cookievoorkeuren block): prefill from
	// the current consent, save through the engine so onChange does the rest.
	function syncForm() {
		var form = document.getElementById('cookieconsentform');
		if (!form) return;
		form.querySelectorAll('input[type=checkbox][data-ccform]').forEach(function (box) {
			var cat = box.getAttribute('data-ccform');
			if (!box.disabled) box.checked = CC.acceptedCategory(cat);
		});
	}
	function wireForm() {
		var form = document.getElementById('cookieconsentform');
		if (!form) return;
		syncForm();
		form.addEventListener('submit', function (e) {
			e.preventDefault();
			var accepted = ['functional'];
			form.querySelectorAll('input[type=checkbox][data-ccform]').forEach(function (box) {
				var cat = box.getAttribute('data-ccform');
				if ((box.disabled || box.checked) && accepted.indexOf(cat) === -1) accepted.push(cat);
			});
			CC.acceptCategory(accepted);
			var btn = form.querySelector('button[type=submit]');
			if (btn && !btn.dataset.savedLabel) {
				btn.dataset.savedLabel = btn.textContent;
				btn.textContent = 'Opgeslagen ✓';
				setTimeout(function () {
					btn.textContent = btn.dataset.savedLabel;
					delete btn.dataset.savedLabel;
				}, 2000);
			}
		});
	}

	// "Meer informatie" link under the banner text — only when the site has a
	// cookie-policy page configured (Thema opties).
	var footerLink = cfg.policyUrl
		? '<a href="' + cfg.policyUrl + '">Meer informatie</a>'
		: '';

	CC.run({
		// Bump IBIZZ_CONSENT_REVISION (inc/setup/consent.php) on material policy
		// changes — visitors with an older stored revision are re-prompted.
		revision: Number(cfg.revision || 1),
		cookie: { expiresAfterDays: 365 },

		guiOptions: {
			consentModal: {
				layout: 'box',
				position: 'bottom left',
				// Legal requirement (AP): refusing as easy as accepting.
				equalWeightButtons: true,
				flipButtons: false
			},
			preferencesModal: { layout: 'box', equalWeightButtons: true }
		},

		categories: {
			functional: { enabled: true, readOnly: true },
			analytics: {},
			social: {},
			ads: {},
			interest: {}
		},

		language: {
			default: 'nl',
			translations: {
				nl: {
					consentModal: {
						title: 'Deze website gebruikt cookies',
						description: 'We kunnen cookies plaatsen voor de analyse van onze bezoekersgegevens, om onze website te verbeteren, om gepersonaliseerde inhoud te tonen en om u een geweldige website-ervaring te bieden.',
						acceptAllBtn: 'Accepteren',
						acceptNecessaryBtn: 'Weigeren',
						showPreferencesBtn: 'Beheer voorkeuren',
						footer: footerLink
					},
					preferencesModal: {
						title: 'Cookievoorkeuren',
						acceptAllBtn: 'Alles accepteren',
						acceptNecessaryBtn: 'Alles weigeren',
						savePreferencesBtn: 'Voorkeuren opslaan',
						closeIconLabel: 'Sluiten',
						sections: [
							{
								title: 'Functioneel',
								description: 'Functionele cookies zorgen ervoor dat de website correct functioneert.',
								linkedCategory: 'functional'
							},
							{
								title: 'Analytisch',
								description: 'Analytische cookies meten het bezoek van de website. Met deze cookies verzamelen we bezoekersgegevens op een anonieme wijze. Deze gegevens worden gebruikt voor statistische analyses.',
								linkedCategory: 'analytics'
							},
							{
								title: 'Social Media',
								description: 'Social Media cookies maken het mogelijk om de inhoud van onze website te delen via Social Media. Social Media netwerken doen aan profilering en tracking van bezoekers. Door deze cookies te accepteren kan je internetgedrag gemonitord worden door Social Media.',
								linkedCategory: 'social'
							},
							{
								title: 'Advertentie',
								description: 'Met Advertentie cookies kunnen advertenties worden afgestemd op jouw surfgedrag. Door deze cookies te accepteren kan je surfgedrag gemonitord worden door advertentienetwerken en kunnen adverteerders via een online-veiling advertenties plaatsen bij bezoekers die waarschijnlijk belangstelling hebben voor hun producten of diensten.',
								linkedCategory: 'ads'
							},
							{
								title: 'Interesse',
								description: 'Interesse cookies zorgen ervoor dat we de inhoud van onze website voor jou kunnen optimaliseren, op basis van jouw interesses. Zonder deze cookies krijg je een standaard aanbod op onze website.',
								linkedCategory: 'interest'
							}
						]
					}
				}
			}
		},

		onFirstConsent: function (param) {
			gtagUpdate();
			logConsent(param.cookie);
		},
		onConsent: function () {
			// Every load with valid consent: keep Consent Mode + the form in sync.
			gtagUpdate();
			syncForm();
		},
		onChange: function (param) {
			gtagUpdate();
			logConsent(param.cookie);
			syncForm();
		}
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', wireForm);
	} else {
		wireForm();
	}
})();
